









































































































































































































import { computed, defineComponent, reactive } from '@vue/composition-api'
import moment from 'moment'
import queryString from 'query-string'

import { UserRole } from '@/types/user'
import { QlogState, UserState } from '@/types/store'
import {
  LogParams,
  workerTypes,
  workTargets,
  workResults,
  approvalResults,
  isModifieds,
} from '@/types/log'

import useVuex from '@/utils/useVuex'
import { baseURL } from '@/api/axios-default'

import Layout from '@/components/organisms/common/Layout.vue'
import { LogsTable } from '@/components/organisms/logs'

type Props = {}

export default defineComponent({
  name: 'QuestionnaireAdminLogs',
  components: { Layout, LogsTable },
  setup(props: Props, context) {
    const store = context.root.$store
    const state = reactive({
      logs: useVuex<QlogState['logs']>(
        context,
        () => store.getters['qlog/logs'],
      ),
      isLogsLoading: useVuex<QlogState['isLogsLoading']>(
        context,
        () => store.getters['qlog/isLogsLoading'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      questionnaireId: null,
      questionnaireAnswerId: null,
      isDateStartAtOpen: false,
      dateStartAt: moment().format('YYYY-MM-DD'),
      isDateEndAtOpen: false,
      dateEndAt: moment().format('YYYY-MM-DD'),
      workedById: null,
      castId: '',
      castName: '',
      workerType: null,
      receiptId: null,
      workTarget: null,
      isModified: null,
      workResult: null,
      approvalResult: null,
    })

    const canCsvDownload = computed<boolean>(() => {
      return 0 < state.logs.length && state.logs.length < 10000
    })

    const generateParams = computed<LogParams>(() => {
      return {
        questionnaireId: state.questionnaireId,
        questionnaireAnswerId: state.questionnaireAnswerId,
        dateStartAt: moment(state.dateStartAt).toDate(),
        dateEndAt: moment(state.dateEndAt).toDate(),
        workedById: state.workedById,
        castId: state.castId,
        castName: state.castName,
        workerType: state.workerType,
        receiptId: state.receiptId,
        workTarget: state.workTarget,
        isModified: state.isModified,
        workResult: state.workResult,
        approvalResult: state.approvalResult,
      }
    })

    const downloadUrl = computed<string>(() => {
      const raw = generateParams.value
      const queryObj: Record<string, string> = {}
      Object.keys(raw).forEach(key => {
        if ((raw as any)[key]) {
          if (key.endsWith('At')) {
            queryObj[key] = moment((raw as any)[key]).toISOString()
          } else {
            queryObj[key] = (raw as any)[key]
          }
        }
      })
      const query = queryString.stringify(queryObj)
      return `${baseURL}logs/logs.csv?${query}`
    })

    const search = () => {
      store.dispatch('qlog/getLogs', generateParams.value)
    }

    return {
      state,
      canCsvDownload,
      downloadUrl,
      search,
      UserRole,
      workerTypes,
      workTargets,
      workResults,
      approvalResults,
      isModifieds,
    }
  },
})
